import {useState, useEffect} from 'react';
import '../core.scss'
import './AuthenticationStyle.scss';
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import axiosServise from '../ApiService';
import {ToastContainer, toast} from 'react-toastify';
import axios from 'axios';
import {useNavigate} from "react-router-dom";
import {
    MDBContainer,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
}
    from 'mdb-react-ui-kit';
import Cookies from 'js-cookie';
import {baseApiCore} from '../Constants';
import {Row, Col} from "react-bootstrap";
import PrettyBox from "../PrettyBox/PrettyBox.tsx";
import {Typography} from "@mui/material";
import {Menu} from "../../Entities/Menu.ts";
import TopMenu from "../TopMenu/TopMenu.tsx";

export default function Authentication() {
    const [current, setCurrent] = useState('')


    const nav = useNavigate();
    const [justifyActive, setJustifyActive] =
        useState<'logIn' | 'forgetPassword' | 'singUp' | 'detectionPassword' | String>('logIn');
    const {
        register: registerSingUp,
        handleSubmit: handleSubmitSingUp,
        formState: {errors: errorsSingUp},
        watch
    } = useForm();
    const {register: registerLogIn, handleSubmit: handleSubmitLogIn, formState: {errors: errorsLogIn}} = useForm()
    const {
        register: registerForgetPassword,
        handleSubmit: handleSubmitForgetPassword,
        formState: {errors: errorsForgetPassword}
    } = useForm()
    const {
        register: registerDetectionPassword,
        handleSubmit: handleSubmitDetectionPassword,
        formState: {errors: errorsDetectionPassword}
    } = useForm()
    const handleJustifyClick = (value) => {
        if (value === justifyActive) {
            return;
        }
        setJustifyActive(value);
    };

    const onSubmitSingUp = data => {
        if (data.Password === data.RetypePassword) {
            document.body.classList.add('loading-Authentication');
            axios.post(`${baseApiCore}authentication/SignUp`, data)
                .then(response => {
                        document.body.classList.remove('loading-Authentication');
                        handleJustifyClick('logIn')
                        toast.success(response.data.message, {
                            position: "bottom-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        })
                    }
                )
                .catch(error => {
                    document.body.classList.remove('loading-Authentication');
                    toast.error(error.response.data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                });
        } else {
            toast.error('.رمز عبور با تکرار رمز عبور مطابقت ندارد', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }
    const onSubmitLogIn = data => {
        document.body.classList.add('loading-Authentication');
        console.log(data);
        console.log(`${baseApiCore}authentication/TokenUser`);
        axios.post(`${baseApiCore}authentication/TokenUser`, data)
            .then(response => {
                    document.body.classList.remove('loading-Authentication');
                    Cookies.set('auth', response.data.content);
                    console.log(response.data.content);
                    nav("/");
                }
            )
            .catch(error => {
                document.body.classList.remove('loading-Authentication');
                toast.error(error.response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }

    const onSubmitForgetPassword = data => {

    }
    const onSubmitDetectionPassword = data => {

    }

    return (
        <div>
            <TopMenu Menus={[
                {
                    "id": "5f8a3530-dff1-4801-8723-bed5d0b74dcf",
                    "title": "ورود",
                    "link": "logIn",
                    "iconId": 'c657cc0c-284e-4292-81bc-e1c7dc79ceff',
                    "parentId": null,
                    "order": "2",
                    "isActive": true
                },
                {
                    "id": "98cbfe71-6392-40a5-adf1-b26399c6a32b",
                    "title": "ثبت نام",
                    "link": "singUp",
                    "iconId": 'a24d0c4c-ef6a-4adb-b92d-9f186760ed5e',
                    "parentId": null,
                    "order": "3",
                    "isActive": true
                }
            ]} OnSelected={(menu) => {
                setJustifyActive(menu.link)
            }}/>
            <Row>
                <Col>

                </Col>
            </Row>
            <Row>
                <Col>
                    <div>
                        {
                            justifyActive === "logIn" ?
                                <>

                                    <form onSubmit={handleSubmitLogIn(onSubmitLogIn)} className='khorshidPishva-form'
                                          style={{marginBottom: "40%", marginTop: "10%"}}>
                                        <div className="mb-3 d-column">
                                            <label className="form-label">شماره موبایل :</label>
                                            <input className='form-control' type="text" maxLength={11}
                                                   placeholder="شماره موبایل" {...registerLogIn("UserName", {
                                                required: "این فیلد الزامی میبشد",
                                                maxLength: 11,
                                                pattern: {
                                                    value: /^[0][9][0-9][0-9]{8,8}$/,
                                                    message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                                },
                                            })} />
                                            <ErrorMessage errors={errorsLogIn}
                                                          name="UserName"
                                                          render={({message}) => <span
                                                              className='erore-massage'>{message}</span>}
                                            />
                                        </div>
                                        <div className="mb-3 d-column">
                                            <label className="form-label">رمز عبور:</label>
                                            <input className='form-control' type={'password'} autoComplete="off"
                                                   placeholder="رمز عبور" {...registerLogIn("Password", {
                                                required: "این فیلد الزامی میبشد",
                                                maxLength: 40,
                                            })} />
                                            <ErrorMessage errors={errorsLogIn}
                                                          name="Password"
                                                          render={({message}) => <span
                                                              className='erore-massage'>{message}</span>}
                                            />
                                        </div>
                                        <div className="mb-3 d-column">
                                            <button className='forgetPassword-btn col-4'
                                                    onClick={() => handleJustifyClick('forgetPassword')}
                                                    active={justifyActive === 'forgetPassword'}>
                                                <span style={{alignSelf: "center"}}>فراموشی رمز عبور</span>
                                            </button>
                                        </div>
                                        <input type="submit" value='ورود' className='submit'/>
                                    </form>

                                </> :
                                justifyActive === 'forgetPassword' ?
                                    <>
                                        <form onSubmit={handleSubmitForgetPassword(onSubmitForgetPassword)}
                                              className='khorshidPishva-form'
                                              style={{marginBottom: "70%", marginTop: "10%"}}>
                                            <div className="mb-3 d-column">
                                                <h6 style={{alignSelf: "center"}}>بازیابی رمز</h6>
                                            </div>

                                            <div className="mb-3 d-column">
                                                <label className="form-label">شماره موبایل :</label>
                                                <input className='form-control' type="text"
                                                       placeholder="شماره موبایل" {...registerForgetPassword("Mobile2", {
                                                    required: "این فیلد الزامی میبشد",
                                                    maxLength: 11,
                                                    pattern: {
                                                        value: /^[0][9][0-9][0-9]{8,8}$/,
                                                        message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                                    },
                                                })} />
                                                <ErrorMessage errors={errorsForgetPassword}
                                                              name="Mobile2"
                                                              render={({message}) => <span
                                                                  className='erore-massage'>{message}</span>}
                                                />
                                            </div>
                                            <input type="submit" value='تایید' className='submit'
                                                   onClick={() => handleJustifyClick('detectionPassword')}
                                                   active={justifyActive === 'detectionPassword'}/>
                                        </form>

                                    </> :
                                    justifyActive === "singUp" ?
                                        <>

                                            <form onSubmit={handleSubmitSingUp(onSubmitSingUp)} className='khorshidPishva-form'
                                                  style={{marginBottom: "5%", marginTop: "5%"}}>
                                                <div className="mb-3 d-column">
                                                    <label className="form-label">نام :</label>
                                                    <input className='form-control' type="text" maxLength='40'
                                                           placeholder="نام" {...registerSingUp("FirstName", {
                                                        required: "این فیلد الزامی میبشد",
                                                        pattern: {
                                                            value: /^[\u0600-\u06FF\s]+$/,
                                                            message: "لطفا نام فارسی خود را وارد نمایید",
                                                        },
                                                    })} />
                                                    <ErrorMessage errors={errorsSingUp}
                                                                  name="FirstName"
                                                                  render={({message}) => <span
                                                                      className='erore-massage'>{message}</span>}
                                                    />
                                                </div>
                                                <div className="mb-3 d-column">
                                                    <label className="form-label">نام خانوادگی :</label>
                                                    <input className='form-control' type="text" maxLength='40'
                                                           placeholder="نام خانوادگی" {...registerSingUp("LastName", {
                                                        required: "این فیلد الزامی میبشد",
                                                        pattern: {
                                                            value: /^[\u0600-\u06FF\s]+$/,
                                                            message: "لطفا نام فارسی خود را وارد نمایید",
                                                        },
                                                    })} />
                                                    <ErrorMessage errors={errorsSingUp}
                                                                  name="LastName"
                                                                  render={({message}) => <span
                                                                      className='erore-massage'>{message}</span>}
                                                    />
                                                </div>

                                                <div className="mb-3 d-column">
                                                    <label className="form-label">شماره موبایل :</label>
                                                    <input className='form-control' type="text" maxLength='11'
                                                           placeholder="شماره موبایل" {...registerSingUp("MobileNumber", {
                                                        required: "این فیلد الزامی میبشد",
                                                        pattern: {
                                                            value: /^[0][9][0-9][0-9]{8,8}$/,
                                                            message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                                        },
                                                    })} />
                                                    <ErrorMessage errors={errorsSingUp}
                                                                  name="MobileNumber"
                                                                  render={({message}) => <span
                                                                      className='erore-massage'>{message}</span>}
                                                    />
                                                </div>
                                                <div className="mb-3 d-column">
                                                    <label className="form-label">رمز عبور:</label>
                                                    <input className='form-control' type={'password'} minLength='8'
                                                           maxLength='30'
                                                           autoComplete="off"
                                                           placeholder="رمز عبور" {...registerSingUp("Password", {
                                                        required: "این فیلد الزامی میبشد",
                                                        maxLength: 40,
                                                    })} />
                                                    <ErrorMessage errors={errorsSingUp}
                                                                  name="Password"
                                                                  render={({message}) => <span
                                                                      className='erore-massage'>{message}</span>}
                                                    />
                                                </div>
                                                <div className="mb-3 d-column">
                                                    <label className="form-label">تکرار رمز عبور:</label>
                                                    <input className='form-control' type={'password'} autoComplete="off"
                                                           placeholder="تکرار رمز عبور" {...registerSingUp("RetypePassword", {
                                                        required: "این فیلد الزامی میبشد",
                                                        maxLength: 40,
                                                    })} />
                                                    <ErrorMessage errors={errorsSingUp}
                                                                  name="RetypePassword"
                                                                  render={({message}) => <span
                                                                      className='erore-massage'>{message}</span>}
                                                    />
                                                </div>
                                                <input type="submit" value='ثبت نام' className='submit'/>
                                            </form>

                                        </> :
                                        justifyActive === 'detectionPassword' ?
                                            <>
                                                <form onSubmit={handleSubmitDetectionPassword(onSubmitDetectionPassword)}
                                                      className='khorshidPishva-form'
                                                      style={{marginBottom: "70%", marginTop: "10%"}}>
                                                    <div className="mb-3 d-column">
                                                        <h6 style={{alignSelf: "center"}}>تغییر رمز عبور</h6>
                                                    </div>
                                                    <div className="mb-3 d-column">
                                                        <label className="form-label">کد تایید:</label>
                                                        <input className='form-control' type="text"
                                                               placeholder="شماره موبایل" {...registerDetectionPassword("Mobile2", {
                                                            required: "این فیلد الزامی میبشد",
                                                            maxLength: 11,
                                                            pattern: {
                                                                value: /^[0][9][0-9][0-9]{8,8}$/,
                                                                message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                                            },
                                                        })} />
                                                        <ErrorMessage errors={errorsDetectionPassword}
                                                                      name="Mobile2"
                                                                      render={({message}) => <span
                                                                          className='erore-massage'>{message}</span>}
                                                        />
                                                    </div>
                                                    <div className="mb-3 d-column">
                                                        <label className="form-label">رمز عبور:</label>
                                                        <input className='form-control' type="text"
                                                               placeholder="رمز عبور" {...registerDetectionPassword("password", {
                                                            required: "این فیلد الزامی میبشد",
                                                            maxLength: 40,
                                                        })} />
                                                        <ErrorMessage errors={errorsDetectionPassword}
                                                                      name="password"
                                                                      render={({message}) => <span
                                                                          className='erore-massage'>{message}</span>}
                                                        />
                                                    </div>
                                                    <div className="mb-3 d-column">
                                                        <label className="form-label">تکرار رمز عبور:</label>
                                                        <input className='form-control' type="text"
                                                               placeholder="تکرار رمز عبور" {...registerDetectionPassword("repeatPassword", {
                                                            required: "این فیلد الزامی میبشد",
                                                            maxLength: 40,
                                                        })} />
                                                        <ErrorMessage errors={errorsDetectionPassword}
                                                                      name="repeatPassword"
                                                                      render={({message}) => <span
                                                                          className='erore-massage'>{message}</span>}
                                                        />
                                                    </div>

                                                    <input type="submit" value='ارسال' className='submit'/>
                                                </form>

                                            </> :
                                            <></>
                        }
                    </div>
                </Col>
            </Row>

        </div>

    )
}
